<template>
  <div>
    <hi-card v-for="(item, index) in applyList" :key="item.processInstanceId" :row-index="index + 1">
      <van-row>
        <span>申请单号：</span>
        <span>{{ item.applyCode }}</span>
      </van-row>
      <van-row>
        <span>供应商名称：</span>
        <span>{{ item.suppName }}</span>
      </van-row>
      <van-row>
        <span>供货品类：</span>
        <span>{{ item.catgName }}</span>
      </van-row>
      <van-row>
        <span>企业属性：</span>
        <span>{{ item.enterpriseNature | dictFilter(enterpriseNatureOptions) }}</span>
      </van-row>
      <van-row>
        <span>交易形式：</span>
        <span>{{ item.transactionForm | dictFilter(transactionFormOptions) }}</span>
      </van-row>
      <van-row>
        <span>代理品牌：</span>
        <span>{{ item.agentBrand }}</span>
      </van-row>
      <van-row>
        <span>代理原厂：</span>
        <span>{{ item.agentFactory }}</span>
      </van-row>
      <van-row>
        <span>企业类型：</span>
        <span>{{ item.enterpriseType | dictFilter(enterpriseTypeOptions) }}</span>
      </van-row>
      <van-row>
        <span>结果适用公司：</span>
        <span>{{ item.applyCorpName }}</span>
      </van-row>
      <van-row>
        <span>当前合作状态：</span>
        <span>{{ item.suppStatus | dictFilter(suppStatusOptions) }}</span>
      </van-row>
      <van-row>
        <span>申请时间：</span>
        <span>{{ item.crtTime }}</span>
      </van-row>
      <van-row>
        <span>计划完成时间：</span>
        <span>{{ item.planFinishDate }}</span>
      </van-row>
      <van-row>
        <span>供应商认定结果：</span>
        <span>{{ item.checkResultDict | dictFilter(checkResultDictOptions) }}</span>
      </van-row>
    </hi-card>
  </div>
</template>

<script>
export default {
  name: 'ApplyInfo',
  components: {},
  data() {
    return {}
  },
  props: {
    applyList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    enterpriseNatureOptions() {
      return this.$store.getters.dicts.enterprise_type
    },
    transactionFormOptions() {
      return this.$store.getters.dicts.trade_type
    },
    enterpriseTypeOptions() {
      return this.$store.getters.dicts.enterprise_character
    },
    suppStatusOptions() {
      return this.$store.getters.dicts.supp_status
    },
    checkResultDictOptions() {
      return this.$store.getters.dicts.yes_no
    }
  }
}
</script>
